import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as supplierActions from "../../../../../actions/supplierAction";
import * as SupplierCategoryAction from "../../../../../actions/supplierCategoryAction";
import SupplierUsagePlanDetail from "./SupplierUsagePlanDetail";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(SupplierUsagePlanDetail)
);
